<template>
    <div class="repoItem" @click="goDetail">
        <div class="repoTitle">
            <div class="gameTit">
                <span class="imgBox">
                    <img :src="itemData.game_icon" alt="">
                </span>
                <span class="gameName" v-text="itemData.game_name"></span>
            </div>
            <div class="starLevel">
                <span class="starItem" :class="{shine:itemData.grade>0}"></span>
                <span class="starItem" :class="{shine:itemData.grade>1}"></span>
                <span class="starItem" :class="{shine:itemData.grade>2}"></span>
                <span class="starItem" :class="{shine:itemData.grade>3}"></span>
                <span class="starItem" :class="{shine:itemData.grade>4}"></span>
            </div>
        </div>
        <hr>
        <div class="repoContent">
            <h3 v-text="itemData.question_title"></h3>
            <p v-text="itemData.question_content"></p>
        </div>
        <div class="repoFoot" @click="showMore">
            <span class="stateBar" :class="'state_'+itemData.work_order_status" v-text="stateMap[itemData.work_order_status]"></span>
            <span class="time">
                <img src="../../images/time.svg" alt="">
                {{itemData.create_time}}
            </span>
        </div>

    </div>
</template>

<script>

    export default {
        name: 'repoItem',
        props: [
            'itemData'
        ],
        data() {
            return {
                detail: false,
                stateMap: {
                    1: this.$t('service.noReply'),
                    2: this.$t('service.processing'),
                    3: this.$t('service.replied'),
                    4: this.$t('service.closedCases')
                }
            };
        },
        methods: {
            showMore(){
                
            },
            goDetail(){
                this.$router.push({name:'serviceH5OrderDetail',query:{id: this.itemData.work_order_id}});                
            }
        },
        created() {},
        mounted() {}
    };
</script>

<style lang="scss" scoped>
    
    $cl_green : #50BBE5;
    $cl_dark : #444444;
    
    .repoItem{
        background-color: #F2F2F2;
        border-radius: .12rem;
        padding: .12rem .12rem .2rem;
        margin-bottom: .1rem;
        .repoTitle{
            font-size: .14rem;
            color: $cl_dark;
            height: .2rem;
            .gameTit{
                float: left;
                .imgBox{
                    display: inline-block;
                    height: .2rem;
                    width: .2rem;
                    overflow: hidden;
                    border-radius: .05rem;
                    margin-right: .04rem;
                    border: 1px solid rgba(68,68,68,0.20);
                    box-sizing: border-box;
                    vertical-align: middle;
                    img{
                        display: block;
                        width: .2rem;
                    }
                }
                .gameName{
                    vertical-align: middle;
                    color: $cl_dark;
                    font-size: .12rem;
                }
            }
            .starLevel{
                float: right;
                font-size: 0;
                padding: .04rem 0;
                .starItem{
                    display: inline-block;
                    height: .12rem;
                    width: .12rem;
                    margin-right: .04rem;
                    background: url(../../images/star.svg) center center no-repeat;
                    background-size: contain;
                    &.shine{
                        background-image: url(../../images/star_b.svg)
                    }
                }
            }
        }
        hr{
            margin: .12rem 0;
            border: 0;
            height: .01rem;
            background-color: #DDDDDD;
        }
        .repoContent{
            font-size: .12rem;
            line-height: .16rem;
            h3{
                font-size: .14rem;
                line-height: .19rem;
                margin: 0 0 .04rem;
                color: $cl_dark;
            }
            p{
                font-size: .12rem;
                line-height: .16rem;
                margin: 0;
                max-height: .64rem;
                overflow: hidden;
                color: #999999;
            }
        }
        .repoFoot{
            height: .14rem;
            line-height: .14rem;
            margin-top: .2rem;
            .stateBar{
                display: block;
                float: left;
                line-height: .14rem;
                height: .14rem;
                width: auto;
                font-size: .1rem;
                color: #ffffff;
                text-align: center;
                border-radius: .07rem;
                padding: 0 0.05rem;
                &.state_1{
                    background-color: #999999;
                }
                &.state_2{
                    background-color: #FFA0A0;
                }
                &.state_3{
                    background-color: #8FD7C1;
                }
                &.state_4{
                    background-color: #cccccc;
                }
            }
            .time{
                display: block;
                float: right;
                color: #999999;
                font-size: .1rem;
                img{
                    display: inline-block;
                    width: .1rem;
                    margin-left: .04rem;
                }
            }
        }
    }
</style>